import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: [],
    links: {},
    meta: {},
    filtros: {
      status: null,
      cod: null,
      nome: null,
      usuario: null,
      usuario_tipo: {
        id: null
      },
      associacao: {
        value: {}
      }
    }
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    RESET_USUARIOS: state => {
      state.usuarios.loading = false;
      state.usuarios.filtros = {
        status: null,
        cod: null,
        nome: null,
        usuario: null,
        usuario_tipo: {
          id: null
        },
        associacao: {
          value: null
        },
        entidade: {
          value: null
        }
      };
    },

    SET_USUARIOS_LOADING: (state, loading) => {
      state.usuarios.loading = loading;
    },

    SET_USUARIOS: (state, { data, links, meta }) => {
      state.usuarios.data = data;
      state.usuarios.links = links;
      state.usuarios.meta = meta;
    },

    SET_USUARIO: (state, { data }) => {
      state.usuarios.usuario = data;
    },

    SET_USUARIOS_FILTROS: (state, filtros) => {
      state.usuarios.filtros = {
        ...state.usuarios.filtros,
        ...filtros
      };
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    isUsuariosLoading: state => () => {
      return state.usuarios.loading;
    },

    getUsuarios: state => () => {
      return state.usuarios.data;
    },

    getUsuarioEditar: state => () => {
      return state.usuarios.data;
    },

    getUsuariosMeta: state => () => {
      return state.usuarios.meta;
    },

    getUsuariosLinks: state => () => {
      return state.usuarios.links;
    },

    hasUsuariosFiltros: state => () => {
      if (cod) return true;
      if (nome) return true;
      if (entidade) return true;

      return false;
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_USUARIOS(
      { commit, state },
      {
        page,
        nome,
        email,
        cpf,
        tipoUsuario,
        associacao,
        entidade,
        sortedBy,
        orderBy
      }
    ) {
      // Se ja esta buscando
      if (state.usuarios.loading) return;
      commit("SET_USUARIOS_LOADING", true);
      api()
        .get(`usuarios`, {
          params: queryParams({
            page: page,
            relationships: ["usuarioTipo", "associacao", "entidade"],
            where: [
              ["nome", "like", nome],
              ["email", "like", email],
              ["cpf", "like", cpf],
              ["usuario_tipo_id", "=", tipoUsuario],
              ["associacao_id", "=", associacao],
              ["entidade_id", "=", entidade]
            ],
            sortedBy: sortedBy,
            orderBy: orderBy
          })
        })
        .then(response => {
          if (response.data.status) {
            commit("SET_USUARIOS", response.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_USUARIOS_LOADING", false));
    },
    FETCH_USUARIO({ commit }, usuario_id) {
      api()
        .get(`usuarios/${usuario_id}`, {
          params: queryParams({
            relationships: ["usuarioTipo", "entidade"]
          })
        })
        .then(response => {
          if (response.data.status) {
            commit("SET_USUARIOS", response.data);
          }
        });
    },
    SAVE_USUARIO: function ({ commit }, usuario) {
      return new Promise((resolve, reject) => {
        api()
          .post(`usuarios`, usuario)
          .then(response => {
            if (response.data.status) resolve(response.data);
          })
          .catch(error => reject(error));
      });
    },
    UPDATE_USUARIO({ commit }, usuario) {
      return new Promise(resolve => {
        api()
          .put(`usuarios/${usuario.id}`, usuario)
          .then(response => {
            if (response.status) {
              resolve(response.data);
            }
          });
      });
    },
    RESET_USUARIOS({ commit }) {
      commit("RESET_USUARIOS");
    },

    SET_USUARIOS_FILTROS({ commit }, filtros) {
      commit("SET_USUARIOS_FILTROS", filtros);
    }
  }
};

export default store;
